import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'pagos',
})
export class PagosPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (items) {

      if (filter['id_cierre'] > 0) {

        items = items.filter(function (item) {
          return item.id_cierre == filter['id_cierre'];
        });
      }

    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/pagos/pagos.ts